<template>
  <div class="ongjinenglish-wrapper">
    <img src="@/assets/img/ongjinenglish/ongjinenglish.jpg" alt="img" />

    <ul class="btn-list">
      <li>
        <a
          href="https://apply.carrotenglish.net/start?idx=132327"
          target="_blank"
        >
          <img src="@/assets/img/ongjinenglish/btn1.png" alt="img" />
        </a>
      </li>
      <li>
        <a
          href="https://apply.carrotenglish.net/start?idx=132328"
          target="_blank"
        >
          <img src="@/assets/img/ongjinenglish/btn2.png" alt="img" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.ongjinenglish-wrapper {
  position: relative;
  max-width: 800px;
  margin: 0 auto;

  img {
    display: block;
    width: 100%;
  }

  .btn-list {
    display: flex;
  }
}
</style>
